import { defaultState } from "./state";
import structure from "./action-types";
import commonTypes from "../common/action-types";

const types = { ...commonTypes, ...structure };

const systemUsers = (systemUsersState = defaultState.systemUsers, action) => {
  switch (action.type) {
    case types.SET_SYSTEM_USERS:
      return action.data;

    case types.ADD_OR_UPDATE_SYSTEM_USER: {
      const tmpState = [...systemUsersState];
      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else tmpState.unshift(action.data);

      return tmpState;
    }

    case types.REMOVE_SYSTEM_USER: {
      const tmpState = [...systemUsersState];

      const index = tmpState.findIndex(
        ({ userEntityId }) => userEntityId === action.userEntityId
      );

      if (index >= 0) tmpState.splice(index, 1);

      return tmpState;
    }

    case types.CLEAN_STATE:
      return defaultState.systemUsers;

    default:
      return systemUsersState;
  }
};

const degrees = (degreesState = defaultState.degrees, action) => {
  switch (action.type) {
    case types.SET_DEGREES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.degrees;

    default:
      return degreesState;
  }
};

const specializations = (
  specializationsState = defaultState.specializations,
  action
) => {
  switch (action.type) {
    case types.SET_SPECIALIZATIONS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.specializations;

    default:
      return specializationsState;
  }
};

const teacherProfile = (
  teacherProfileState = defaultState.teacherProfile,
  action
) => {
  switch (action.type) {
    case types.SET_TEACHER_PROFILE:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.teacherProfile;

    default:
      return teacherProfileState;
  }
};

const profileDocumentTypes = (
  profileDocumentTypesState = defaultState.profileDocumentTypes,
  action
) => {
  switch (action.type) {
    case types.SET_PROFILE_DOCUMENT_TYPES:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.profileDocumentTypes;

    default:
      return profileDocumentTypesState;
  }
};

const profileDocuments = (
  profileDocumentsState = defaultState.profileDocuments,
  action
) => {
  switch (action.type) {
    case types.SET_PROFILE_DOCUMENTS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.profileDocuments;

    default:
      return profileDocumentsState;
  }
};

const schoolLeadersEvaluations = (
  schoolLeadersEvaluationsState = defaultState.schoolLeadersEvaluations,
  action
) => {
  switch (action.type) {
    case types.SET_SCHOOL_LEADERS_EVALUATIONS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.schoolLeadersEvaluations;

    default:
      return schoolLeadersEvaluationsState;
  }
};

// Appeal reducers
const currentAppeal = (
  currentAppealState = defaultState.currentAppeal || null,
  action
) => {
  switch (action.type) {
    case types.SET_CURRENT_APPEAL:
      return action.data;

    case types.CLEAN_STATE:
      return null;

    default:
      return currentAppealState;
  }
};

const myAppeals = (
  myAppealsState = defaultState.myAppeals || [],
  action
) => {
  switch (action.type) {
    case types.SET_MY_APPEALS:
      return action.data;

    case types.CLEAN_STATE:
      return [];

    default:
      return myAppealsState;
  }
};

export default {
  systemUsers,
  degrees,
  specializations,
  teacherProfile,
  profileDocumentTypes,
  profileDocuments,
  schoolLeadersEvaluations,
  currentAppeal,
  myAppeals,
};
